<template>
  <div class="container">
    <!-- 面包屑导航 -->
    <breadcrumb :breadcrumbConfig="breadcrumbConfig"></breadcrumb>
    <!--    <breadcrumb></breadcrumb>-->
    <!-- 面包屑导航 -->
    <div class="content">
      <h2>抖店订单</h2>
      <h3>数据筛选</h3>
      <form-filed class="search-form" :formconfig="searchFormConfig.formconfig" :formData="searchFormConfig.formData"
                  @formDataval="dialogClick" @formDataval1="dialogClick1" ref="formAttr"></form-filed>
    </div>
    <div class="content">
      <h3>列表数据</h3>
      <div class="but-list">
        <div class="left">
          <el-button v-for="(val, key) in logisticsStatus" :key="key" :disabled="loading"
                     :type="currentStatus === val.values ? 'primary' : 'info'" size="small" plain
                     @click="onChangeLogisticsStatus(val.values)">{{ val.title }}({{ val.total }})
          </el-button>
        </div>
        <div class="right">
          <el-button type="primary" size="small" v-if="currentStatus == '2'" @click="onStockUp(true)">批量解密
          </el-button>
          <el-button type="primary" size="small" v-if="currentStatus == null" @click="onStockMark(true)">批量标记
          </el-button>
          <el-button type="primary" size="small" @click="exportData()">导出
          </el-button>
        </div>
      </div>
      <orders-list-table v-loading="loading" :dataList="page.list" :heightStr="columns.height" :config="columns.config"
                         :typeStr="columns.type" @optionDialog="optionDialog" @lookDialog="lookDialog"
                         @tableSelectionChange="tableSelectionChange"></orders-list-table>
      <!-- 分页start -->
      <div class="page" style="float: right; margin: 10px 10px; padding-bottom: 10px">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page.sync="page.currentPage" :page-sizes="[3, 5, 10, 20, 50]" :page-size="page.pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="page.totalNum">
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="dialogVisible" append-to-body width="40%">
      <div style="margin-bottom: 10px">
        <el-form ref="dialogForm" :model="dialogForm" label-width="80px" :rules="rules">
          <el-form-item label="物流公司" prop="logisticsCompany">
            <el-select style="width: 100%" v-model="dialogForm.logisticsCompany" placeholder="请选择物流公司" filterable>
              <el-option v-for="(item, index) in dictionaries.courier_company" :key="index" :label="item.dictName"
                         :value="item.dictId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物流单号" prop="logisticsNumber">
            <el-input v-model="dialogForm.logisticsNumber" placeholder="请输入物流单号"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div style="margin-top: 20px; text-align: center">
        <el-button @click="dialogVisible = false" plain style="margin-right: 20px">取消</el-button>
        <el-button type="primary" @click="submit">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="物流信息" :visible.sync="dialogLook" append-to-body width="40%">
      <StepLogistics :stepProgress="logisticsMessage"></StepLogistics>

      <!-- <div style="margin-top: 20px; text-align: center">
          <el-button @click="dialogLook = false" plain style="margin-right: 20px"
            >取消</el-button
          >
          <el-button type="primary" @click="submit">确定</el-button>
        </div> -->
    </el-dialog>
    <el-dialog title="导出记录" :visible.sync="dialogRecord" append-to-body width="40%">
      <lb-table :column="columnsDeriveRecord" :data="deriveRecordList.list" pagination :total="deriveRecordList.totalNum"
                layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
                :current-page.sync="page.currentPage" :page-size="page.pageSize" @size-change="handleSizeChangeDeriveRecord"
                @p-current-change="handleCurrentChangeDeriveRecord">
      </lb-table>

      <div style="margin-top: 20px; text-align: center">
        <el-button @click="dialogRecord = false" plain style="margin-right: 20px">取消</el-button>
        <el-button type="primary" @click="dialogRecord = false">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="inTitle" :visible.sync="dialogIn" append-to-body width="640px">
      <template class="importlogistics">
        <div>
          <el-upload style="width: 100%" ref="tops" class="upload-demo" accept=".doc,.docx,.xls,.xlsx,.csv" drag
                     action="#" :multiple="false" :http-request="orderImport" :limit="1">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
        </div>
      </template>
      <div style="margin-top: 20px; display: flex; justify-content: space-between">
        <div @click="downloadTemplate">
          <el-button type="text" icon="el-icon-download">导入模板下载</el-button>
        </div>
        <div>
          <el-button @click="
            dialogIn = false;
          $refs['tops'].clearFiles();
          " plain
                     style="margin-right: 20px">取消</el-button>
          <el-button type="primary" @click="
            submitIn();
          $refs['tops'].clearFiles();
          ">确定</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="批量标记" :visible.sync="isMark" width="30%" :append-to-body="true">
      <div slot="title" class="dialog-title">
        <span style="font-size: 18px;font-family: PingFang SC;font-weight: bold;line-height: 25px;">批量标记</span>
        <span style="color:#4168E7">（已选 {{ selectD.length }} 条订单）</span>
      </div>
      <div class="content">
        <el-form ref="infoForm" style="margin-top: 10px;">
          <el-form-item label="是否电子面单">
            <el-select v-model="isUpdateMark" placeholder="请选择" style="width: 70%">
              <el-option v-for="item in isOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div style="display: flex;justify-content: end;margin-top: 40px;margin-bottom: 10px;">

          <div class="cBtn" @click="isMark = false">取消</div>
          <div class="qBtn" @click="submitLotOf">确定</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import formFiled from '@/components/form/index'
import breadcrumb from '@/components/breadcrumb'
import LbTable from '@/components/lb-table/lb-table'
import CloseOrder from './components/CloseOrder'
import StepProgress from '@/components/StepProgress'
import modifyOrderNo from './components/modifyOrderNo'
import StepLogistics from './components/StepLogistics.vue'

import mixinsCommon from './mixins/common.js'
import OrdersListTable from './components/OrdersListTableL'
// import M from 'minimatch'
import { before } from 'xe-utils/methods'

export default {
  mixins: [mixinsCommon],
  components: {
    formFiled,
    breadcrumb,
    LbTable,
    CloseOrder,
    StepProgress,
    modifyOrderNo,
    OrdersListTable,
    StepLogistics
  },
  data() {
    return {
      isUpdateMark: null,
      isOptions: [
        // {
        //   label:'--',
        //   value:null,
        // },
        {
          label: '是',
          value: true,
        },
        {
          label: '否',
          value: false,
        }
      ],
      dialogIn: false,
      dialogRecord: false,
      dialogLook: false,
      dialogForm: {
        logisticsCompany: '',
        logisticsNumber: '',
      },
      logisticsMessage: {},
      rules: {

        logisticsCompany: [
          { required: true, message: '请选择物流公司', trigger: 'change' }
        ],
        logisticsNumber: [
          { required: true, message: '请输入物流单号', trigger: 'blur' },
        ],
      },
      dialogVisible: false,
      title: '发货',
      formType: '',
      loadinglist: false,
      btnLoading: false, // 导出物流数据加载
      titleName: '', //
      loading: false,
      sessionDictionaries: {}, // 缓存字典
      wuliuStatus: {
        resource: '',
        remark: ''
      },
      wuliuAbnormalId: '',
      currentPage1: 1,
      pageTotalNum: '', // 待备货商品的数量
      commWarehouseList: '', // 仓库数据
      importLogisticsList: [], // 导入物流单号失败的数据
      file: '', // 文件上传
      setCloseOrder: '', // 关闭原因选择值
      dialoglogistics: { visible: false, title: '编辑', type: '', row: {}, batch: false }, // 导入物流单号
      deriveRecordList: [], // 导出记录列表数据
      currentStatus: '',
      logisticsStatus: {
        totalCount: { title: '全部', values: null, total: 0 }, // 全部
        waitingPayCount: { title: '待支付', values: 1, total: 0 },
        waitingStockingCount: { title: '已支付', values: 105, total: 0 },
        waitingDeliveryCount: { title: '备货中', values: 2, total: 0 },
        halfDeliveredCount: { title: '部分发货', values: 101, total: 0 },
        deliveredCount: { title: '已发货', values: 3, total: 0 },
        receivedCount: { title: '已完成', values: 5, total: 0 },
        closedCount: { title: '已取消', values: 4, total: 0 },
        //   errorCount: { title: '异常订单', values: 99, total: 0 }
      },
      statusCount: { // 物流订单分页数量统计
        totalCount: 100, // 全部数量
        waitingPayCount: 12,
        waitingStockingCount: 12,
        stockedCount: 12,
        deliveredCount: 13,
        waitingDeliveryCount: 14,
        receivedCount: 10,
        closedCount: 10
      },
      multipleSelection: [],
      page: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      breadcrumbConfig: {
        list: [
          {
            title: '订单管理',
            type: '#ff0000',
            path: '/'
          },
          {
            title: '抖店订单',
            type: '1',
            path: ''
          }
        ]
      },

      itemListSplice: [],
      itemListAll: [],
      orgCodevalue: '',
      searchFormVal: {},
      searchFormConfig: {
        formconfig: {
          labeWidth: 100, // 表单宽度
          itemList: [// 表单的list
            { type: 'input', prop: 'orderId', placeholder: '请输入订单编号', label: '订单编号', size: 'small' },
            { type: 'input', prop: 'goodsName', placeholder: '请输入商品名称', label: '商品名称', size: 'small' },
            { type: 'input', prop: 'postUserInfo', placeholder: '请输入收货人信息', label: '收货人信息', size: 'small' },
            {
              type: 'select', prop: 'orderType', placeholder: '请选择订单类型', label: '订单类型', size: 'small',
              option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2' }]
            },
            {
              type: 'select', prop: 'payType', placeholder: '请选择支付方式', label: '支付方式', size: 'small',
              option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2' }]
            },

            { type: 'daterange', prop: 'createTime', placeholder: '请选择日期', label: '下单时间', size: 'small' },
            { type: 'daterange', prop: 'payTime', placeholder: '请选择日期', label: '支付时间', size: 'small' },
            { type: 'daterange', prop: 'shipTime', placeholder: '请选择日期', label: '发货时间', size: 'small' },
            {
              type: 'select', prop: 'bType', placeholder: '请选择订单来源', label: '订单来源', size: 'small',
              option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2' }]
            },
            {
              type: 'select', prop: 'decryptFlag', placeholder: '请选择解密状态', label: '解密状态', size: 'small',
              option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2' }]
            },
            {
              type: 'select', prop: 'shopId', placeholder: '请选择店铺来源', label: '店铺来源', size: 'small',
              option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2' }]
            },
            {
              type: 'select', prop: 'ebillFlag', placeholder: '请选择是否电子面单', label: '是否电子面单', size: 'small',
              option: [{ label: '选择一', value: 'key1' }, { label: '选择二', value: 'key2' }]
            },
          ],
          btnarry: [// 表单按钮
            { name: '查询', click: 'add', type: 'primary', plain: false, size: 'small' },
            { name: '重置', click: 'clrear', type: 'primary', plain: true, size: 'small' }
          ]
        },
        formData: { // 表单提交数据，
          orderGenerateType: '',
          checkbox: [],// 注：如果类型是checkbox，必须foemData里边提前声明数组,
          orderStatus: ''
        }
      },
      orgCodevalue: '',
      columnsDeriveRecord: [
        { label: '文件名', prop: 'fileName', minWidth: '230' },
        { label: '操作人', prop: 'userName', minWidth: '100' },
        { label: '导出时间', prop: 'createdDate', minWidth: '200' },
        {
          label: '操作', width: '100',
          render: (h, scope) => {
            return (
                <div>
                  <el-link type='primary' size='mini' onClick={() => {
                    this.downloadlink(scope.row.excelUrl)
                  }}>下载
                  </el-link>
                </div>
            )
          }
        }
      ],
      columns: {
        type: 'afterOrder',
        height: '5000px',
        sortObj: {},
        config: [
          { type: 'selection', width: 50 },
          { prop: 'orderId', label: '订单编号', width: 150, slot: 'orderId' },
          { prop: 'goodsInfo', label: '商品信息', slot: 'goodsInfo', width: 440 },

          // { prop: 'price', label: '单价/数量', slot: 'price', width: 200 },
          { prop: 'orderAmount', label: '应付', width: 150, slot: 'orderAmount' },
          { prop: 'orderTypeLabel', label: '订单类型', width: 150, slot: 'orderTypeLabel' },
          { prop: 'userInfo', label: '收货人信息', slot: 'userInfo', width: 200 },
          { prop: 'ebillFlag', label: '是否电子面单', slot: 'ebillFlag', width: 200 },
          { prop: 'orderStatusLabel', label: '订单状态', width: 100, slot: 'orderStatusLabel' },
          { prop: 'decryptFlag', label: '解密状态', width: 100, slot: 'decryptFlag' },


          { prop: 'remark', label: '备注', slot: 'remark', width: 80 },
        ]
      },
      dictionaries: {},
      orderId: '',
      file: '',
      inTitle: '导入物流单',
      selectD: [],
      orderIds: [],
      isMark: false
    }
  },
  watch: {
    searchFormConfig: {
      handler(newVal, oldVal) {
        console.log(newVal.formData)
        // this.currentStatus = Number(newVal.formData.orderStatus)
        // console.log(this.currentStatus)

      },
      deep: true
    },

  },
  created() {
    if (this.$route.query.status) {
      this.currentStatus = this.$route.query.status
      this.searchFormVal.orderStatus = this.currentStatus
      this.page.pageNo = 1
      this.page.pageSize = 10
      this.page.currentPage = 1
    }
    this.initSearchList() // 初始化，搜索需要的列表数据
    this.goodsPlatforms()
    this.getDictionaries('dou_order_type')
    this.getDictionaries('dou_pay_type')
    this.getDictionaries('dou_b_type')
    this.getDictionaries('dou_shop_id')
    this.fetchData()
    // this.getStatusCountL()
    let list = []
    const payIndex = this.searchFormConfig.formconfig.itemList.findIndex(e => { return e.label === '解密状态' })
    list[0] = {
      value: false,
      label: '未解密'
    }
    list[1] = {
      value: true,
      label: '已解密'
    }
    this.searchFormConfig.formconfig.itemList[payIndex].option = list

  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(_ => {
        // 获取本地缓存字典
        const sessionDictionaries = JSON.parse(sessionStorage.getItem('dictionaries'))
        if (sessionDictionaries) {
          this.sessionDictionaries = sessionDictionaries
        }
        // this.fetchData()
      }, 1000)
    })
  },
  methods: {
    submitLotOf() {
      let orderIds = []
      this.selectD.forEach(item => {
        orderIds.push(item.orderId)
      })
      let data = {
        orderIds: orderIds,
        ebillFlag: this.isUpdateMark
      }
      this.axios.post('/outorder/dou/order/updateEbillFlag', data)
          .then(res => {
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '更改成功'
              });
              this.isMark = false
              this.fetchData('search')
            } else {
              this.$message.error(res.message)
            }
          })
    },
    //导出
    exportData() {
      let orderIds = []
      this.selectD.forEach(item => {
        orderIds.push(item.orderId)
      })
      this.searchFormVal.orderIds = orderIds
      if (this.currentStatus == '') {
        this.currentStatus = null
      }
      if (this.searchFormVal.payTime) {
        this.searchFormVal.payTimeStart = this.searchFormVal.payTime[0]
        this.searchFormVal.payTimeEnd = this.searchFormVal.payTime[1]
      }
      if (this.searchFormVal.createTime) {
        this.searchFormVal.createTimeStart = this.searchFormVal.createTime[0]
        this.searchFormVal.createTimeEnd = this.searchFormVal.createTime[1]
      }
      if (this.searchFormVal.shipTime) {
        this.searchFormVal.shipTimeStart = this.searchFormVal.shipTime[0]
        this.searchFormVal.shipTimeEnd = this.searchFormVal.shipTime[1]
      }
      this.searchFormVal.orderStatus = this.currentStatus
      this.axios.post('/outorder/dou/order/export', this.searchFormVal).then(res => {
        if (res.code == 0) {
          this.downloadlink(res.data)
          this.$message({
            type: 'success',
            message: '导出成功!'
          })
          this.fetchData('search')
        }
      })
    },
    downloadlink(url) {
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = url
      document.body.appendChild(iframe)
    },
    tableSelectionChange(e) {
      console.log(e)
      this.selectD = e
    },
    getStatusCountL() {
      // this.searchFormVal.orderStatus = null
      let params = {}
      const searchForm = this.searchFormVal
      params = Object.assign(params, searchForm)
      if (params.payTime) {
        params.payTimeStart = params.payTime[0]
        params.payTimeEnd = params.payTime[1]
      }
      if (params.createTime) {
        params.createTimeStart = params.createTime[0]
        params.createTimeEnd = params.createTime[1]
      }
      if (params.shipTime) {
        params.shipTimeStart = params.shipTime[0]
        params.shipTimeEnd = params.shipTime[1]
      }
      this.axios.post('/outorder/dou/order//orderCount', params).then(res => {
        if (res.code == 0) {
          this.statusCount = res.data
          this.logisticsStatus.totalCount.total = this.statusCount.totalCount
          this.logisticsStatus.waitingPayCount.total = this.statusCount.waitingPayCount
          this.logisticsStatus.waitingStockingCount.total = this.statusCount.waitingStockingCount
          this.logisticsStatus.waitingDeliveryCount.total = this.statusCount.waitingDeliveryCount
          this.logisticsStatus.halfDeliveredCount.total = this.statusCount.halfDeliveredCount
          this.logisticsStatus.deliveredCount.total = this.statusCount.deliveredCount
          this.logisticsStatus.receivedCount.total = this.statusCount.receivedCount
          this.logisticsStatus.closedCount.total = this.statusCount.closedCount
        } else {
          this.$message.error(res.message)
        }
      })
    },
    submitIn() {
      const formData = new FormData()
      formData.append('file', this.file)
      if (this.inTitle == '导入物流单') {
        formData.append('updateSupport', 0)
      } else {
        formData.append('updateSupport', 1)
      }
      console.log(formData)
      this.$api.inlogisticsOrder(formData).then(res => {
        if (res.code == 0) {
          this.dialogIn = false
          if (res.data.importErrorNumber != 0) {
            this.$message.error('导入失败！')
            this.downloadlink(res.data.errorUrl)
          } else {
            this.$message.success('导入成功！')
            this.fetchData('search')
          }

        }
      })
    },
    // 导入物流单号模板下载
    downloadTemplate() {
      const exportModelUrl = this.sessionDictionaries.export_model_url
      let modelIndex
      // console.log(this.currentStatus, this.logisticsStatus.stayDeliverGoods.values)
      if (this.currentStatus === this.logisticsStatus.waitDeliverGoods.values || this.currentStatus === this.logisticsStatus.waitDeliverGoods.values) {
        modelIndex = exportModelUrl.findIndex(item => { return item.dictId === 'logistics_number_import_success' }) // 待发货
      }
      this.downloadlink(exportModelUrl[modelIndex].dictName)
    },
    // 导入物流单
    orderImport(fileObj) {
      this.file = fileObj.file
    },
    leadingIn(val) {
      this.dialogIn = true
      if (val == 0) {
        this.inTitle = '导入物流单'
      } else {
        this.inTitle = '批量修改物流单'
      }

    },
    importLogisticsData(val) {
      this.$refs.formAttr.submitForm('ruleForm')
      console.log(this.searchFormVal)
      const ids = []
      if (this.multipleSelection.length != 0) {
        this.multipleSelection.forEach((item) => {
          ids.push(item.id)
        })
      }
      let data = {
        status: val,
        pageNo: this.page.currentPage,
        pageSize: this.page.pageSize,
      }
      const searchForm = this.searchFormVal
      data = Object.assign(data, searchForm)
      if (data.postTime) {
        data.postTime = data.postTime
        data.postTimeStart = data.postTime[0]
        data.postTimeEnd = data.postTime[1]
      }
      data.orderIdList = ids
      this.$api.exportlogisticsData(data).then((res) => {
        if (res.code == 0) {
          this.downloadlink(res.data)
          this.btnLoading = false
          // this.downloadlink(res.data)
          this.$message.success('操作成功！')
          this.fetchData('search')
        } else {
          this.btnLoading = false
        }
      }).catch((err) => {
        console.log(err)
        this.btnLoading = false
      })
    },
    // 导出
    importLogisticsOrder() {
      this.$refs.formAttr.submitForm('ruleForm')
      console.log(this.searchFormVal)
      const ids = []
      if (this.multipleSelection.length != 0) {
        this.multipleSelection.forEach((item) => {
          ids.push(item.id)
        })
      }
      let data = {

      }
      const searchForm = this.searchFormVal
      data = Object.assign(data, searchForm)
      if (data.postTime) {
        data.postTimeStart = data.postTime[0]
        data.postTimeEnd = data.postTime[1]
      }
      if (data.createdTime) {
        data.createdTimeStart = data.createdTime[0]
        data.createdTimeEnd = data.createdTime[1]
      }
      data.orderIdList = ids
      this.$api.exportlogisticsOrder(data).then((res) => {
        if (res.code == 0) {
          this.downloadlink(res.data)
          this.btnLoading = false
          // this.downloadlink(res.data)
          this.$message.success('操作成功！')
          this.fetchData('search')
        } else {
          this.btnLoading = false
        }
      }).catch((err) => {
        console.log(err)
        this.btnLoading = false
      })
    },
    // 导出记录列表查询
    onApplierExport() {
      this.dialogRecord = true

      const params = {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
      }
      this.$api.exportRecord(params).then((res) => {
        if (res.code == 0) {
          this.deriveRecordList = res.data
        }
        // this.downloadlink(res.data)
      }).catch((err) => {
        console.log(err)
      })
    },
    // 每页条数
    handleSizeChangeDeriveRecord(val) {
      this.page.currentPage = 1
      this.page.pageSize = val
      this.onApplierExport()
    },
    // 当前页
    handleCurrentChangeDeriveRecord(val) {
      this.page.pageNo = val
      this.onApplierExport()
    },
    // tableSelectionChange(val) {
    //   console.log(val)
    //   this.multipleSelection = val
    // },
    //导出发货
    deriveDeliverGoods() {
      let params = {}
      let arr = []
      this.multipleSelection.forEach(item => {
        arr.push(item.id)
      })
      const searchForm = this.searchFormVal
      params = Object.assign(params, searchForm)
      params.orderIdList = arr
      params.orderStatus = 3
      this.$api.exportDelivery(params).then(res => {
        if (res.code == 0) {
          this.downloadlink(res.data)
          this.$message({
            type: 'success',
            message: '导出成功!'
          })
          this.currentStatus = 3
          this.fetchData()
        }
      })
    },
    downloadlink(url) {
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = url
      document.body.appendChild(iframe)
    },
    // 批量解密
    onStockUp(batch, obj) {
      // true 批量
      // const params = { ids: [] }
      // if (batch) {
      //   const multipleSelection = this.multipleSelection
      //   if (multipleSelection.length === 0) {
      //     return this.$message.warning('请选择数据！')
      //   } else {
      //     multipleSelection.forEach(item => {
      //       params.ids.push(item.id)
      //     })
      //   }
      // } else {
      //   params.ids.push(obj.id)
      // }
      const params = { orderIdList: [] }
      console.log(this.selectD)
      if (this.selectD.length === 0) {
        return this.$message.warning('请选择数据！')
      } else {
        this.selectD.forEach(item => {
          params.orderIdList.push(item.orderId)
        })
      }
      this.$confirm('是否确认解密所选订单?', '批量解密', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = {
          orderIdList: params.orderIdList
        }
        this.axios.post('/outorder/dou/order/decryptPhone', data).then((res) => {
          if (res.code === 0) {
            this.fetchData()
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
            // this.currentStatus = 2
            this.fetchData('search')
          } else {
            this.$message.error(res.message)
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 批量标记
    onStockMark(batch, obj) {
      if (this.selectD.length == 0) {
        this.$message.warning('请选择数据')
        return
      }
      this.isMark = true
    },
    onChangeLogisticsStatus(val) {
      this.currentStatus = val
      console.log(this.searchFormConfig.formData)
      // this.searchFormConfig.formData.orderStatus = String(val)
      // this.searchFormVal.orderStatus = val

      // let orderStatusList = []
      // if (val == '') {
      //   orderStatusList = []
      // } else {
      //   orderStatusList.push(val)
      // }

      // this.searchFormVal.orderStatusList = orderStatusList
      this.page.pageNo = 1
      this.page.pageSize = 10
      this.page.currentPage = 1
      this.fetchData()
    },
    // 物流信息
    getlogistics(id) {
      const params = {
        id: id
      }
      this.$api.getOrderLogisticsInfo(params).then(res => {
        if (res.code == 0) {
          if (this.dictionaries.order_status_logistics.length !== 0 && res.data.status) {
            res.data.statusCn = this.dictionaries.order_status_logistics.find(e => { return e.dictId === res.data.status }).dictName
          }
          if (this.dictionaries.courier_company.length !== 0 && res.data.logisticsCompany) {
            res.data.logisticsCompanyCN = this.dictionaries.courier_company.find(e => { return e.dictId === res.data.logisticsCompany }).dictName
          }
          // console.log(logisticsCompany)
          this.logisticsMessage = res.data
          // this.logisticsMessage.logisticsCompany = logisticsCompany
        }
      })
    },
    submit() {
      this.$refs['dialogForm'].validate((valid) => {
        if (valid) {
          let data = {
            orderId: this.orderId,
            logisticsCompany: this.dialogForm.logisticsCompany,
            logisticsNumber: this.dialogForm.logisticsNumber
          }
          if (this.title == '发货') {
            this.$api.logisticsDelivery(data).then(res => {
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '发货成功'
                })
                this.fetchData()
                this.dialogVisible = false
              }

            })
          } else {
            this.$api.updateLogisticsNo1(data).then(res => {
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '更改成功'
                })
                this.fetchData()
                this.dialogVisible = false
              }
            })
          }
        } else {
          return false;
        }
      });

    },
    lookDialog(val) {
      this.dialogLook = true
      this.getlogistics(val.id)
    },
    //操作
    optionDialog(val) {
      if (val.type == 'delivery') {
        this.title = '发货'
        this.dialogVisible = true
        this.orderId = val.val.id
        this.dialogForm.logisticsNumber = ''
        this.dialogForm.logisticsCompany = ''
      } else {
        this.title = '修改物流单号'
        this.dialogVisible = true
        this.orderId = val.val.id
        this.dialogForm.logisticsNumber = val.val.logisticsNumber
        this.dialogForm.logisticsCompany = val.val.logisticsCompany
      }

    },
    // 获取字典数据
    getDictionaries(type) {
      const params = { groupId: type }
      this.$api.dictionaries(params).then((res) => {
        if (type == 'dou_b_type') {
          let list = []
          list = res.data
          const payIndex = this.searchFormConfig.formconfig.itemList.findIndex(e => { return e.label === '订单来源' })
          list.forEach(item => {
            item.label = item.dictName
            item.value = item.dictId
          })
          this.searchFormConfig.formconfig.itemList[payIndex].option = list
        }
        if (type == 'dou_pay_type') {
          let list = []
          list = res.data
          const payIndex = this.searchFormConfig.formconfig.itemList.findIndex(e => { return e.label === '支付方式' })
          list.forEach(item => {
            item.label = item.dictName
            item.value = item.dictId
          })
          this.searchFormConfig.formconfig.itemList[payIndex].option = list
        }
        if (type == 'dou_order_type') {
          let list = []
          list = res.data
          const payIndex = this.searchFormConfig.formconfig.itemList.findIndex(e => { return e.label === '订单类型' })
          list.forEach(item => {
            item.label = item.dictName
            item.value = item.dictId
          })
          this.searchFormConfig.formconfig.itemList[payIndex].option = list
        }
        if (type == 'dou_shop_id') {
          let list = []
          list = res.data
          const payIndex = this.searchFormConfig.formconfig.itemList.findIndex(e => { return e.label === '店铺来源' })
          list.forEach(item => {
            item.label = item.dictName
            item.value = item.dictId
          })
          this.searchFormConfig.formconfig.itemList[payIndex].option = list
        }
        const payIndex = this.searchFormConfig.formconfig.itemList.findIndex(e => { return e.label === '是否电子面单' })
        let arr = [
          {
            label: '是',
            value: true
          },
          {
            label: '否',
            value: false
          }
        ]
        this.searchFormConfig.formconfig.itemList[payIndex].option = arr
        if (type == 'courier_company') {
          this.dictionaries.courier_company = res.data
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    goodsPlatforms() {
      const params = {
        userId: null,
        username: null,
        phone: null,
        vipLevel: null,
        categoryIds: null,
        openTimeStart: null,
        openTimeEnd: null,
        status: 1
      }
      this.$api.goodsPlatforms(params).then((res) => {
        let platformList = []
        platformList = res.data
        const payIndex = this.searchFormConfig.formconfig.itemList.findIndex(e => { return e.label === '来源平台' })
        platformList.forEach(item => {
          item.label = item.name
          item.value = item.id
        })
        this.searchFormConfig.formconfig.itemList[payIndex].option = platformList
      }).catch((err) => {
        console.log(err)
      })
    },
    // 初始化，搜索需要的列表数据
    initSearchList() {
      const params = { pageNo: 1, pageSize: 1001 }
    },
    dialogClick(val, state) {
      this.searchFormVal = val
      console.log(this.searchFormVal, 'searchFormVal')
      this.fetchData('search')
      // this.formFiledData = Object.assign(this.formFiledData, val)
      // console.log(this.formFiledData,'接受表单组件的数据');
    },
    dialogClick1(val, state) {
      this.searchFormVal = val
      console.log(this.searchFormVal, 'searchFormVal')
      // this.fetchData('search')
      // this.formFiledData = Object.assign(this.formFiledData, val)
      // console.log(this.formFiledData,'接受表单组件的数据');
    },
    handlerCascaderValue(value) {
      console.log(value, 'value')
      this.orgCodevalue = value
    },
    fetchData(type) {
      this.loadinglist = true
      if (type === 'reset') {
        this.$refs['searchForm'].resetFields()
        this.page.pageNo = 1
        this.page.pageSize = 10
        this.page.currentPage = 1
      }
      if (this.currentStatus == '') {
        this.currentStatus = null
      }
      let params = {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        status: this.page.status,
        orderStatus: this.currentStatus,
        // orderStatusList: orderStatusList || []
      }
      if (this.searchFormVal.payTime) {
        params.payTimeStart = this.searchFormVal.payTime[0]
        params.payTimeEnd = this.searchFormVal.payTime[1]
      }
      if (this.searchFormVal.createTime) {
        params.createTimeStart = this.searchFormVal.createTime[0]
        params.createTimeEnd = this.searchFormVal.createTime[1]
      }
      if (this.searchFormVal.shipTime) {
        params.shipTimeStart = this.searchFormVal.shipTime[0]
        params.shipTimeEnd = this.searchFormVal.shipTime[1]
      }
      this.searchFormVal.orderStatus = this.currentStatus
      const searchForm = this.searchFormVal
      params = Object.assign(params, searchForm)
      if (type === 'search' || type === 'changePage') {
        this.formType = 'search'
        if (type === 'search') {
          this.page.currentPage = 1
          this.page.pageNo = 1
          params.pageNo = 1
        }

        const searchForm = this.searchFormVal
        params.pageNo = this.page.pageNo
        if (this.currentStatus == '') {
          this.currentStatus = null
        }
        params.orderStatus = this.currentStatus
        params = Object.assign(params, searchForm)
        if (this.searchFormVal.payTime) {
          params.payTimeStart = this.searchFormVal.payTime[0]
          params.payTimeEnd = this.searchFormVal.payTime[1]
        }
        if (this.searchFormVal.createTime) {
          params.createTimeStart = this.searchFormVal.createTime[0]
          params.createTimeEnd = this.searchFormVal.createTime[1]
        }
        if (this.searchFormVal.shipTime) {
          params.shipTimeStart = this.searchFormVal.shipTime[0]
          params.shipTimeEnd = this.searchFormVal.shipTime[1]
        }
        // if (params.orgCode) {
        //   params.orgCode = params.orgCode[params.orgCode.length - 1]
        // }
        // params.categoryId = searchForm.categoryId[searchForm.categoryId.length - 1]
        // 去除字符串 前后 空格
        for (const item in params) {
          if (typeof params[item] === 'string') {
            params[item] = params[item].trim()
          }
        }
      }
      this.axios.post('/outorder/dou/order/pageList', params).then(res => {
        if (res.code === 0) {
          this.page.list = res.data.list
          this.page.totalNum = res.data.totalNum
        } else {
          console.log('goodsPageList - 失败', type)
          this.$message.error(res.message)
        }
        this.loadinglist = false
        this.getStatusCountL()
      })
      // this.$api.logisticsPageList1(params).then((res) => {
      //   if (res.code === 0) {
      //     this.page.list = res.data.list
      //     this.page.totalNum = res.data.totalNum
      //   } else {
      //     console.log('goodsPageList - 失败', type)
      //   }
      //   this.loadinglist = false
      //   this.getStatusCountL()
      //   // this.getStatusCount(params)// 物流订单分页数量统计查询接口
      // }).catch((err) => {
      //   console.log(err)
      //   this.loadinglist = false
      // })
    },
    handleCurrentChange(currentChange) {
      this.page.pageNo = currentChange
      this.searchFormVal.orderStatus = this.currentStatus
      this.fetchData('changePage')
      console.log(currentChange)
    },
    handleSizeChange(sizeChange) {
      this.page.currentPage = 1
      this.page.pageSize = sizeChange
      this.searchFormVal.orderStatus = this.currentStatus
      this.fetchData('search')
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 每页条数
    handleSizeChangeDeriveRecord(val) {
      this.page.currentPage = 1
      this.page.pageSize = val

    },
    // 当前页
    handleCurrentChangeDeriveRecord(val) {
      this.page.pageNo = val

    },
  }
}
</script>

<style scoped lang="scss">
.cBtn {
  width: 120px;
  height: 36px;
  border: 1px solid #D9D9D9;
  opacity: 1;
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  color: #999999;
  text-align: center;
  cursor: pointer;
  margin-right: 12px;
}

.qBtn {
  width: 120px;
  height: 36px;
  background: #4168E7;
  opacity: 1;
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  color: #FFFFFF;
  text-align: center;
  cursor: pointer;
}

/deep/ .hide-content {
  display: none !important;
}

/deep/ .el-button {
  border: none;
}

/deep/ .el-link {
  margin: 0 5px;
}

/deep/ .el-table th>.cell,
/deep/ .el-table td {
  text-align: unset;
}

.but-list:after {
  clear: both;
  display: table;
  content: "";
}

.but-list {
  margin-bottom: 20px;

  .left {
    float: left;

    /deep/ .el-button {
      width: 120px;
      height: 36px;
      border-radius: 4px;
      font-size: 16px;
    }
  }

  .right {
    float: right;

    /deep/ .el-button {
      min-width: 120px;
      height: 36px;
      border-radius: 4px;
      font-size: 16px;
    }

    // 批量备货
    .stay-stock-up-but {
      color: #409eff;
      border: 1px solid #409eff;
      background-color: #ffffff;
    }

    // 导出发货
    .stock-up-send-but {}

    // 导出记录
    .stock-up-record-but {
      background-color: #7763dd;
    }

    // 导出物流单
    .stay-deliver-goods-but {}

    // 批量修改物流单号
    .deliver-goods-but {
      width: 160px;
      height: 36px;
      border: 1px solid #4168e7;
      border-radius: 4px;
      font-size: 16px;
      font-weight: 400;
      color: #4168e7;
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;

  .cancel {
    width: 120px;
    height: 36px;
    border: 1px solid #d9d9d9;
    opacity: 1;
    border-radius: 4px;
  }

  .affirm {
    width: 120px;
    height: 36px;
    background: #4168e7;
    opacity: 1;
    border-radius: 4px;
  }
}

/deep/ .el-upload-dragger {
  width: 600px !important;
}

.dialogBtnright {
  display: flex;
  justify-content: space-between;
}

.dialogBtnright_right {
  display: flex;
  justify-content: right !important;
}

.setPay_payment_btn_quxiao {
  width: 120px;
  height: 36px;
  border: 1px solid #d9d9d9;
  background-color: #ffffff;
  color: rgba(153, 153, 153, 1);
  border-radius: 4px;
  line-height: 0;
}

.setPay_payment_btn_queren {
  width: 120px;
  height: 36px;
  background: #4168e7;
  opacity: 1;
  border-radius: 4px;
  line-height: 0;
  border: 0;
}

.block {
  text-align: right;
}

.setPay_payment {
  display: block;
  margin-bottom: 15px;
}

.dialog-btn {
  text-align: right;
}

/deep/ .el-table__row td .cell span,
/deep/ .el-table__row td .cell div p {
  display: block;
  //overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  /* 可以显示的行数，超出部分用...表示*/
  -webkit-box-orient: vertical;
}

.wuliuAbnormal_box {
  display: flex;
  margin-bottom: 20px;
}

.radio_group {
  margin-left: 20px;
}

.radio_group_item {
  margin-bottom: 10px;
}

.wuliuAbnormal_box_title {
  margin-top: -5px;
}

/deep/.el-select {
  border-left: none;
  border-right: none;

  input {
    border-left: 1px solid #d8dce5 !important;
    border-right: 1px solid #d8dce5 !important;
    border-radius: 5px !important;
  }
}

/deep/.el-scrollbar {
  height: 10px;
}

/deep/.el-scrollbar__bar.is-horizontal {
  height: 9px;
}
</style>
  